import React, { FC } from 'react';
import * as translations from '../strings';
import { getLangKey } from '../../../../../../javascript/models/Language';
import { Button } from 'antd';

import styles from './index.module.css';
import {
  onContactSupport,
  onArticleClick
} from '../../../../../../redesign/javascript/utils/HelpArticleButton';

type Props = {
  taskId: number;
  isSidebar: boolean;
  screenshotKey: string;
};

// @ts-ignore
const strings = translations[getLangKey()];

const Generic: FC<Props> = ({ taskId, isSidebar, screenshotKey }) => {
  return (
    <div className={styles.modalContent}>
      <p className={styles.whyMessage}>
        {strings.errorOccurred}{' '}
        {!screenshotKey && (
          <a
            href="https://support.bugherd.com/articles/11430716-why-did-my-screenshot-not-capture-in-bugherd"
            target="_blank"
            onClick={
              !isSidebar
                ? onArticleClick.bind(null, { articleId: 11430716 })
                : undefined
            }
          >
            {strings.readMore}
          </a>
        )}
      </p>
      {screenshotKey && (
        <p className={styles.whyMoreInfo}>
          {strings.forHelp}{' '}
          <a
            href="mailto:support@bugherd.com"
            className={styles.whyMoreInfoLink}
            onClick={!isSidebar ? onContactSupport : undefined}
          >
            support@bugherd.com
          </a>
          {strings.andMention(taskId)}
        </p>
      )}
      {screenshotKey && (
        <Button type="primary" size="large" className={styles.whyButton}>
          {isSidebar ? (
            strings.contactSupport
          ) : (
            <a
              href="mailto:support@bugherd.com"
              className={styles.anchorButton}
            >
              {strings.contactSupport}
            </a>
          )}
        </Button>
      )}
    </div>
  );
};

export default Generic;
